import { useMutation, useQueryClient } from '@tanstack/react-query';

import { fetcher, throwApiError } from '@commenda/utils';

import { adminManagedAgentsKeys } from './keys';
import type { IAdminManagedAgent, ICreateManagedAgentParams } from './types';

export function useCreateAdminManagedAgent() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (params: ICreateManagedAgentParams) => {
      const response = await fetcher('admin/managed-agents', {
        method: 'POST',
        body: params,
      });
      if (!response.ok)
        await throwApiError(response, 'Failed to create the managed agent');
      return ((await response.json()) as { managedAgent: IAdminManagedAgent })
        .managedAgent;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: adminManagedAgentsKeys.lists(),
      });
    },
  });
}
